import React from 'react'

function CommissionSecondTierIcon(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg
      id="Composant_127_3"
      data-name="Composant 127 – 3"
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="35"
      viewBox="0 0 35 35"
      {...props}
    >
      <g id="Groupe_3402" data-name="Groupe 3402" transform="translate(-863 -1502)">
        <circle
          id="Ellipse_2975"
          data-name="Ellipse 2975"
          cx="17.5"
          cy="17.5"
          r="17.5"
          transform="translate(863 1502)"
          fill="#f1f4f8"
        />
        <path
          id="Soustraction_3"
          data-name="Soustraction 3"
          d="M15,14H0L2.706,8.949h9.588L15,14ZM11.752,7.938h-8.5L7.5,0l4.252,7.937Z"
          transform="translate(873 1511)"
          fill="rgba(96,96,96,0.51)"
        />
      </g>
    </svg>
  )
}

export default CommissionSecondTierIcon
